import { getBranding } from '@/lib/branding'

const APP_NAME_FALLBACK = 'Secret Agents AI'

/** The browser tab's title for a page (SA-1125): `<Title> · <app name>`, the sidebar's fallback name. */
export function documentTitle(title: string): string {
  return `${title} · ${getBranding().appName ?? APP_NAME_FALLBACK}`
}
